const generateCloudinaryLink = (imageID) => {
    if (imageID) {
        if (process.env.REACT_APP_ENV === "production") {
            return `https://res.cloudinary.com/duoj4emk5/image/upload/v1679224586/${imageID}`
        } else {
            return `https://res.cloudinary.com/djodbc4ry/${imageID}`
        }
    }
};

export default generateCloudinaryLink;
